import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bf88444"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination swiper-pagination-custom-position" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["ExpandableModal"], {
    ref: "expandableModalRef",
    maxHeightPx: $setup.props.maxHeightPx,
    baseHeightPx: $setup.baseHeightPx,
    onOnToggleExpanded: $setup.toggleShowLineInfoList
  }, {
    content: _withCtx(() => [
      ($setup.shouldShowLineInfoList)
        ? (_openBlock(), _createBlock($setup["LineInfoList"], {
            key: 0,
            busStop: $props.selectedBusStop,
            lineInfos: $props.lineInfos,
            onOnContentHeightChange: $setup.handleContentHeightChange
          }, null, 8 /* PROPS */, ["busStop", "lineInfos"]))
        : (_openBlock(), _createBlock($setup["Swiper"], _mergeProps({
            key: 1,
            ref: "swiperRef",
            class: "bus-stop-swiper"
          }, $setup.swiperOptions, {
            key: $props.updateKey,
            onSwiper: $setup.onSwiper,
            onSlideChange: $setup.onSlideChange
          }), {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.busStops, (busStop, index) => {
                return (_openBlock(), _createBlock($setup["SwiperSlide"], { key: index }, {
                  default: _withCtx(() => [
                    _createVNode($setup["BusStopInfoSimple"], {
                      class: _normalizeClass(["bus-stop-info", { 'no-pagination': !$setup.hasMultipleBusStops }]),
                      busStop: busStop,
                      lineInfos: $props.lineInfos,
                      onShowAllLineInfoList: $setup.handleShowAllLineInfoList
                    }, null, 8 /* PROPS */, ["class", "busStop", "lineInfos"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              }), 128 /* KEYED_FRAGMENT */)),
              _hoisted_1
            ]),
            _: 1 /* STABLE */
          }, 16 /* FULL_PROPS */))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["maxHeightPx", "baseHeightPx"]))
}